// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__vrkIP","content":"LayoutSettings_content__3vvII"};